module.exports = __webpack_public_path__ + "img/faq.600cbeb2.png";